
import React from 'react'
import { Title, Text, Tooltip } from '@mantine/core';
import { Link } from 'react-router-dom';
import { FaInfoCircle } from "react-icons/fa";
import { useSelector } from 'react-redux';

const StepBoxes = () => {
    const AlertTranslations = useSelector((state) => state.WebsiteLanguage.data.AlertTranslations);
    const GeneralTranslations = useSelector((state) => state.WebsiteLanguage.data.GeneralTranslations);

    return (
        <div className="stepper-base">
            <div className="form-section">
                <div className="content-header">
                    <Title className="form-title" order={2}>{GeneralTranslations.reportCorruption}</Title>
                    <Text className="form-desc" size="lg">{GeneralTranslations.chooseField}</Text>
                </div>
                <div className="feilds">

                    <Link className="feild-btn" to="/Sinjalizim">
                        {GeneralTranslations.signal}
                        <Tooltip
                            multiline
                            sx={{ maxWidth: 500 }}
                            position="top"
                            className="tooltip-konflikt"
                            withArrow
                            arrowSize={8}
                            label={AlertTranslations.SinjalizimiTooltip}
                            color="#051A53"
                        >
                            <div className="icone">
                                <FaInfoCircle />
                            </div>
                        </Tooltip>
                    </Link>


                    <Link className="feild-btn" to="/KonfliktIntersit">
                        {GeneralTranslations.interestsConflict}
                        <Tooltip
                            multiline
                            sx={{ maxWidth: 500 }}
                            position="top"
                            className="tooltip-konflikt"
                            withArrow
                            arrowSize={8}
                            label={AlertTranslations.KonfliktiTooltip}
                            color="#051A53"
                        >
                            <div className="icone">
                                <FaInfoCircle />
                            </div>
                        </Tooltip>
                    </Link>


                    <Link className="feild-btn" to="/DeklarimiPasuriseDheDhuratave">
                        {GeneralTranslations.DeklarimiPasurise}
                        <Tooltip
                            multiline
                            sx={{ maxWidth: 500 }}
                            position="top"
                            className="tooltip-konflikt"
                            withArrow
                            arrowSize={8}
                            label={AlertTranslations.DeklarimiTooltip}
                            color="#051A53"
                        >
                            <div className="icone">
                                <FaInfoCircle />
                            </div>
                        </Tooltip>
                    </Link>


                    <Link className="feild-btn" to="/Tjeter">
                        {GeneralTranslations.Other}
                        <Tooltip
                            multiline
                            sx={{ maxWidth: 500 }}
                            position="top"
                            className="tooltip-konflikt"
                            withArrow
                            arrowSize={8}
                            label={AlertTranslations.OtherTooltip}
                            color="#051A53"
                        >
                            <div className="icone">
                                <FaInfoCircle />
                            </div>
                        </Tooltip>
                    </Link>

                </div>
            </div>

            <div className="apk-form-background">
                <div className='logo'>
                    <img src="/img/logo/web/logo-gray.png" alt="Logo" />
                </div>
            </div>
        </div>
    )
}

export default StepBoxes